import React from 'react'
import styles from './Location.module.css' 
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default function SimpleMap(){
  const defaultProps = {
    center: {
      lat: -10.932107842527337,
      lng: -37.055441526805055
    },
    zoom: 16
  };

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: '400px' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyDKC7vXmpoPpnoZHSuS6HuJ7oxAXf-qvbs" }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
      >
       
        
        <Marker  lat={-10.932107842527337} lng={-37.055441526805055} />
         
      </GoogleMapReact>
    </div>
  );
}

// -10.932107842527337, -37.055441526805055